export default {
  includeInverseLogo: true,
  backgroundColour: 'brandOne100',
  linkColour: 'utilityWhite',
  linkHoverDecoration: 'none',
  linkDividerColor: 'brandOne80',
  smallTextColor: 'brandOne20',
  seperateLinkBar: false,
};
